let techStackData: { tech: string, logo: string}[] = 
    [
        { tech: "React / React Native", logo: '/assets/tech-logos/react-logo.png' },
        { tech: "Next.js", logo: '/assets/tech-logos/next-logo.png' },
        { tech: "TypeScript", logo: '/assets/tech-logos/typescript-logo.png' },
        { tech: "Tailwind CSS", logo: '/assets/tech-logos/tailwind-logo.png' },
        { tech: "Framer Motion", logo: '/assets/tech-logos/framer-motion-logo.png' },
        { tech: "Mapbox", logo: '/assets/tech-logos/mapbox-logo.png' },
        { tech: "Cursor", logo: '/assets/tech-logos/cursor-logo.png' },
        { tech: "Figma", logo: '/assets/tech-logos/figma-logo.png' },
        { tech: "Cypress", logo: '/assets/tech-logos/cypress-logo.png' },
    ]

export default techStackData